import React from "react";
import "./styles.css";

function BackgroundContainer({ children }) {
  return <div className="background-container">{children}</div>;
}

export default BackgroundContainer;
